export enum BoxTransfersRequestType {
  DECLARATION = 'declaration',
  CONTAINER = 'container',
  BRANCH = 'branch',
}

export type BoxTransfersPropsType = {
  requestId?: string | number;
  requestType?: BoxTransfersRequestType;
};

export type IBoxTransferPersistence = {
  id: number;
  declaration: {
    id: number;
    track_code: number;
  };
  from_container: {
    id: number;
    name: string;
  };
  to_container: {
    id: number;
    name: string;
  };
  user: {
    id: number;
    name: string;
  };
  branch: {
    id: number;
    name: string;
  };
  note: string;
  created_at: string;
};

export type IBoxTransferUser = {
  id: number;
  declaration: {
    id: number;
    trackCode: number;
  };
  fromContainer: {
    id: number;
    name: string;
  };
  toContainer: {
    id: number;
    name: string;
  };
  user: {
    id: number;
    name: string;
  };
  branch: {
    id: number;
    name: string;
  };
  note: string;
  createdAt: string;
};
